import { DOCUMENT } from "@angular/common";
import {
  Component,
  EventEmitter,
  Inject,
  NgZone,
  OnDestroy,
  OnInit
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { first, takeUntil } from "rxjs/operators";

import { GrowlService } from "@lantern/app/core/utils/growl-service/growl.service";

import { RedirectService } from "@local/app/common/redirect.service";
import { GlobalAuthService } from "@local/app/core/global-auth";

const DEFAULT_REDIRECT = "/marts";

@Component({
  template: ""
})
export class VerifyMagicTokenComponent implements OnInit, OnDestroy {
  private windowRef: Window;

  constructor(
    private growlService: GrowlService,
    private globalAuthService: GlobalAuthService,
    private activatedRoute: ActivatedRoute,
    private ngZone: NgZone,
    private redirectService: RedirectService,
    private router: Router,
    @Inject(DOCUMENT) documentRef: any
  ) {
    this.windowRef = (documentRef as Document).defaultView!;
  }

  ngOnInit(): void {
    const magicToken = this.activatedRoute.snapshot.queryParams.token;

    this.globalAuthService
      .loginWithMagicToken(magicToken)
      .pipe(first(), takeUntil(this.onDestroyEmitter))
      .subscribe(
        () => {
          this.performRedirect();
        },
        async () => {
          this.growlService.danger("Invalid magic token");
          await this.router.navigateByUrl("/login");
        }
      );
  }

  private onDestroyEmitter = new EventEmitter();
  ngOnDestroy(): void {
    this.onDestroyEmitter.emit();
    this.onDestroyEmitter.complete();
  }

  private performRedirect(): void {
    const redirect = this.activatedRoute.snapshot.queryParams.redirect;
    if (redirect != null) {
      this.redirectService.redirect(redirect);
      return;
    }

    this.globalAuthService
      .getMarts()
      .pipe(first(), takeUntil(this.onDestroyEmitter))
      .subscribe((marts) => {
        if (marts.length === 1) {
          this.windowRef.location.href = `//${marts[0].domain}`;
        } else {
          this.ngZone.run(() => this.router.navigateByUrl(DEFAULT_REDIRECT));
        }
      });
  }
}
